export default {
  MODULE_NAME: 'billing',
};
